import Modal from '../Modal';
import SelectorEngine from '../../utils/dom/selector-engine';
import { ClassNames } from '../../utils/dom/css-classes';

const SELECTOR_PAGE_LAYOUT_MODAL = '#p-page-layout__modal';

export class ModalPageLayout {
	constructor(element) {
		this._element = element;
		this.init();
	}

	init() {
		if (this._element) {
			const modalElement = SelectorEngine.findOne(SELECTOR_PAGE_LAYOUT_MODAL, this._element);
			if (!modalElement) return;

			this.modalInstance = new Modal(modalElement, { backdrop: 'static' });
			this.hideModal();
		}
	}

	showModal() {
		if (this._element) {
			this._element.classList.remove(ClassNames.Hidden);
			this.modalInstance.show();
		}
	}

	hideModal() {
		if (this._element) {
			this.modalInstance.hide();
			this._element.classList.add(ClassNames.Hidden);
		}
	}

	isOpen() {
		return this._element.classList.contains(ClassNames.Hidden);
	}
}

export default ModalPageLayout;
